import { api } from "@/lib/api";

const visitor = () => {
  try {
    let v = localStorage.getItem("gt_vid");
    if (!v) { v = (crypto.randomUUID?.() || `${Date.now()}${Math.random()}`).replace(/[^a-z0-9]/gi, "").slice(0, 32); localStorage.setItem("gt_vid", v); }
    return v;
  } catch { return null; }
};

export const track = (slug, event) => {
  const v = visitor();
  if (v && slug) api.post("/public/track", { slug, event, visitor: v }).catch(() => {});
};
